import gw_os_uprox from "./index.vue";
import store from '../../../store';

jQuery('.os_gw_imc').each(function() {
    new Vue({
        store,
        name : "OS_UPROX",
        el:this,
        data () {
            return {

            }
        },
        created () {

        },
        components : {
            gw_os_uprox
        }
    });
});
